<template>
    <iconComponent
        v-if="name"
        class="svg-container"
        :class="cClass"
        :style="colorStyle"
        :width="cSize"
        :height="cSize"
        v-bind="$attrs" />
</template>

<script setup lang="ts">
const sizes = { 'v-mini': 10, mini: 14, small: 18, default: 22, large: 28, xl: 32, '2xl': 36, '3xl': 40 }
const props = defineProps({
  name: {
    type: String
  },
  filled: { type: Boolean },
  className: { type: String },
  size: {
    type: String,
    default: 'default'
  },
  strokeColor: String,
  fillColor: String,
  color: String
})
const { name, size, color, strokeColor, fillColor, className } = toRefs(props)
const cClass = computed(() => {
  return className?.value
})
const cSize = computed(() => {
  if (!size.value || !Object.keys(sizes).includes(size.value)) {
    return 10
  }
  return sizes[size.value as keyof typeof sizes]
})
const colorStyle = computed(() => {
  return {
    color: color?.value,
    stroke: strokeColor?.value || color?.value,
    fill: fillColor?.value || 'none'
  }
})
const iconComponent = defineAsyncComponent(() => import(`@/public/assets/svg/${name?.value}.svg`))
</script>
